// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsEpicGroupsPage_pageDescription__NKUrI"};